import { SORT_OPTIONS } from '../../util/dashboardSort.js';
import { useDismissOnEscape } from './FilterDropdown.jsx';
import { useRef, useState } from 'react';

// T270(6) — the sort control for the mobile card list.
// T142 — single-select sort menu. Drives the same (sortKey, sortDir) state as
// the clickable column headers; useful on mobile (no headers) and for discovery.
export default function SortMenu({ sortKey, sortDir, onSetSort }) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);
  useDismissOnEscape(open, () => setOpen(false), triggerRef);
  const current = SORT_OPTIONS.find((o) => o.key === sortKey && o.dir === sortDir);
  return (
    <div className="relative">
      <button
        ref={triggerRef}
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="rounded-md border border-slate-700 px-3 py-1.5 text-xs text-slate-300 transition hover:border-brand-600 hover:text-brand-400"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        Sort: {current ? current.label : 'Custom'} ▾
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} aria-hidden="true" />
          <div
            role="listbox"
            className="absolute right-0 z-40 mt-1 min-w-[160px] rounded-md border border-slate-700 bg-slate-900 p-1 shadow-lg"
          >
            {SORT_OPTIONS.map((o) => {
              const on = !!current && o.key === current.key && o.dir === current.dir;
              return (
                <button
                  key={`${o.key}-${o.dir}`}
                  type="button"
                  role="option"
                  aria-selected={on}
                  onClick={() => {
                    onSetSort(o.key, o.dir);
                    setOpen(false);
                  }}
                  className={
                    'flex w-full items-center justify-between rounded px-2 py-1.5 text-left text-xs transition ' +
                    (on ? 'bg-brand-600/15 text-brand-500' : 'text-slate-300 hover:bg-slate-800')
                  }
                >
                  <span>{o.label}</span>
                  {on && <span>✓</span>}
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
